var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrashCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2187,
    stopColor: "#b6d600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#acc900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#9ab400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    stopColor: "#829700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 471.179,
    y2: 505.986
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.024,
    x2: 539.488,
    xlinkHref: "#lg1",
    y1: 153.248,
    y2: 538.681
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.518,
    x2: -122.447,
    xlinkHref: "#lg1",
    y1: 282.426,
    y2: 282.426
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-1 0 0 1 510 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 319.354,
    x2: 104.614,
    xlinkHref: "#lg1",
    y1: 282.426,
    y2: 282.426
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 25.631,
    y2: 73.783
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a6313",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2921,
    stopColor: "#5a6117",
    stopOpacity: 0.292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5773,
    stopColor: "#585c23",
    stopOpacity: 0.577
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8587,
    stopColor: "#565436",
    stopOpacity: 0.859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f43"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.611,
    x2: 190.461,
    xlinkHref: "#lg2",
    y1: 72.051,
    y2: 25.593
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.131,
    x2: 303.695,
    xlinkHref: "#lg2",
    y1: 69.574,
    y2: 23.689
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a6313",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3766,
    stopColor: "#5a6216",
    stopOpacity: 0.377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6138,
    stopColor: "#595e1e",
    stopOpacity: 0.614
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8118,
    stopColor: "#57582d",
    stopOpacity: 0.812
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9882,
    stopColor: "#545041",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f43"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.963,
    x2: 240.342,
    xlinkHref: "#lg3",
    y1: 297.508,
    y2: -5.333
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 64.409,
    y2: 112.412
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 415.653,
    y2: 498.254
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 3.836,
    y2: 41.316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.848,
    x2: 152.028,
    xlinkHref: "#lg3",
    y1: 388.499,
    y2: 311.93
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.763,
    x2: 269.918,
    xlinkHref: "#lg3",
    y1: 446.086,
    y2: 287.967
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.659,
    x2: 227.888,
    xlinkHref: "#lg3",
    y1: 366.75,
    y2: 167.039
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.452,
    x2: 314.523,
    xlinkHref: "#lg4",
    y1: 200.196,
    y2: 388.302
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.197,
    x2: 218.268,
    xlinkHref: "#lg4",
    y1: 227.864,
    y2: 415.97
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.406,
    x2: 310.099,
    xlinkHref: "#lg4",
    y1: 201.966,
    y2: 388.757
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m123.846 477.587v9.653c0 7.402 6.433 13.706 15.231 14.981 34.145 4.948 73.721 7.779 115.923 7.779s81.778-2.831 115.923-7.778c8.798-1.275 15.231-7.58 15.231-14.981v-9.653c0-9.364-10.113-16.507-21.265-14.999-32.74 4.427-70.144 6.942-109.89 6.942s-77.15-2.515-109.89-6.942c-11.151-1.508-21.263 5.634-21.263 14.998z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.996 71.011-23.677 357.604-2.536 38.303c-.697 10.531-8.852 19.028-19.342 20.185-39.332 4.336-82.772 6.738-128.441 6.738s-89.109-2.402-128.441-6.738c-10.491-1.157-18.645-9.654-19.342-20.185l-2.536-38.303-23.677-357.604z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.681 71.011-17.238 357.604-1.846 38.303c-.508 10.531-6.445 19.028-14.082 20.185-28.637 4.336-60.263 6.738-93.514 6.738s-64.877-2.402-93.514-6.738c-7.638-1.157-13.575-9.654-14.082-20.185l-1.846-38.303-17.24-357.604z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.527 71.011 6.868 357.604.736 38.303c.202 10.531 2.568 19.028 5.611 20.185 11.41 4.336 24.011 6.738 37.259 6.738s25.849-2.402 37.259-6.738c3.043-1.157 5.409-9.654 5.611-20.185l.736-38.303 6.868-357.604z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.261 65.01c0 20.699-324.521 20.699-324.521 0s72.646-37.479 162.26-37.479 162.261 16.78 162.261 37.479z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.377 29.244c-6.268.454-12.374.993-18.289 1.613-.343 2.023-.532 4.098-.532 6.217v4.79c0 2.909 1.447 5.475 3.657 7.032l31.358 31.358c11.552.201 23.331.294 35.093.277z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.912 30.856c-5.915-.619-12.021-1.158-18.289-1.613 1.035 2.404 1.614 5.05 1.614 7.83v4.79c0 2.774 1.318 5.235 3.357 6.808l29.87 29.87c10.44-.547 20.241-1.208 29.152-1.981z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.093 102.563 322.464 322.464 23.439-354.016h-347.992z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.725 73.247v13.313c0 10.208 9.284 18.903 21.981 20.661 49.277 6.823 106.391 10.728 167.295 10.728s118.018-3.904 167.295-10.728c12.696-1.758 21.981-10.453 21.981-20.661v-13.313c0-12.915-14.594-22.765-30.688-20.685-47.251 6.105-101.231 9.573-158.589 9.573s-111.338-3.468-158.587-9.573c-16.094-2.08-30.688 7.77-30.688 20.685z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.007 403.333 1.674 25.283 2.536 38.303c.697 10.531 8.852 19.028 19.342 20.185 39.332 4.336 82.772 6.738 128.441 6.738s89.109-2.402 128.441-6.738c10.491-1.156 18.645-9.654 19.342-20.185l2.536-38.303 1.674-25.283z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.84 50.467c-4.751 0-8.603-3.851-8.603-8.603v-4.79c0-10.955-8.912-19.866-19.867-19.866h-60.74c-10.955 0-19.867 8.911-19.867 19.866v4.79c0 4.752-3.852 8.603-8.603 8.603s-8.603-3.851-8.603-8.603v-4.79c0-20.443 16.631-37.074 37.073-37.074h60.739c20.443 0 37.074 16.631 37.074 37.073v4.79c0 4.752-3.852 8.604-8.603 8.604z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m404.33 443.57-1.55 23.35c-.69 10.53-8.85 19.03-19.34 20.18-.89.1-1.79.2-2.69.29-23.12 2.49-47.63 4.31-73.15 5.36l-143.19-143.2c-3.12-2.52-4.799-5.65-6.859-9.33-5.76-10.26-5.55-22.37.57-32.41l7.56-11.39-1.171-1.091c-1.66-.9-9.37-9.38-9.37-9.38-4.67-2.53-4.78-8.189-.18-10.869l46.76-27.19c3.94-2.3 8.8-1.111 9.96 3.029z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.33 352.99-5.01 75.63-.43 6.47-.56 8.48-1.55 23.35c-.69 10.53-8.85 19.03-19.34 20.18-.89.1-1.79.2-2.69.29l-139.49-139.5c-4.35-2.65-4.35-7.969 0-10.619l46.19-28.16c3.98-2.42 8.94-1.211 10.1 2.959l15.46 14.63h13.27c.32 0 1.29 0 1.92-1.12s.13-1.95-.04-2.21l-16.829-29.26c-1.45-2.39-2.18-5.09-2.18-7.78s-.271-4.389 1.179-6.779c5.78-9.49 19.5-10.541 25.39-1.171z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.45 305.82-3.12 47.17-5.01 75.63-.43 6.47-123.37-123.37-68.02-68.02c-6.53-4.1-8.339-13.06-3.819-20.46l4.37-7.17 14.96-24.54c5.87-9.64 15.109-15.38 26.389-15.38 9.81 0 18.83 4.35 24.87 11.81l21.52 21.29 5.83-3.36c3.98-2.29 8.8-.05 9.94 4.04z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m353.681 307.81-13.095-21.479-4.742-7.778c-5.824-9.552-19.694-9.552-25.517.002-2.911 4.775-2.911 10.776-.001 15.552l12.758 20.935 5.075 8.324c.168.266.674 1.098.044 2.217s-1.598 1.119-1.918 1.119h-28.485v-12.778c0-5.313-5.815-8.578-10.351-5.813l-46.187 28.155c-4.352 2.653-4.352 8.973 0 11.626l46.187 28.155c4.537 2.766 10.351-.5 10.351-5.813v-13.646h28.484c11.759 0 22.218-6.118 27.973-16.372 5.759-10.253 5.542-22.37-.576-32.406z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.036 326.703h-30.518c-.321 0-1.288 0-1.918-1.119s-.125-1.951.043-2.222l5.075-8.319 5.237-8.594 11.689 6.334c4.671 2.531 10.312-1.025 10.042-6.332l-2.75-54.022c-.259-5.091-5.815-8.101-10.221-5.539l-46.759 27.195c-4.593 2.671-4.492 9.339.179 11.87l11.508 6.236-9.523 15.62c-6.118 10.036-6.336 22.153-.576 32.407 5.754 10.253 16.214 16.372 27.973 16.372h30.518c8.313 0 15.028-6.785 14.942-15.098-.084-8.193-6.749-14.789-14.941-14.789z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.527 207.08c.158-.261.641-1.049 1.875-1.049 1.233 0 1.717.793 1.875 1.049l5.483 8.993 7.054 11.574-10.999 6.329c-4.605 2.65-4.535 9.318.125 11.871l47.439 25.99c4.47 2.449 9.948-.703 10.076-5.798l1.367-54.074c.134-5.311-5.596-8.723-10.201-6.073l-11.896 6.846-12.931-21.209c-5.868-9.634-16.111-14.382-27.391-14.382s-21.523 4.748-27.391 14.382l-14.964 24.544-4.369 7.166c-6.07 9.957 1.097 22.719 12.758 22.719 5.211 0 10.045-2.715 12.758-7.164l13.852-22.721z",
    fill: "url(#SVGID_17_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashCan);
export default __webpack_public_path__ + "static/media/icon-trash-can.9770244b3263bf4deaa81addd2e7d919.svg";
export { ForwardRef as ReactComponent };